/**
 * Minicart item component
 *
 * @module cart-item-price
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "cart-item-price";

if (!customElements.get(customElements.component)) {
  class cartItemPrice extends HTMLElement {
    /**
     * Minicart item web component
     *
     * @constructor
     */
    constructor() {
      super();
      window.theme.cart.getItem(this.id).then((cartItem) => {
        this.render(cartItem);
      });
    }

    render(cartItem) {
      this.innerHTML = `
        <div class="product-final-price">${theme.money.format(
          cartItem.final_price * this.dataset.qtyAdded
        )}</div>
      `;

      this.getPriceRules(cartItem);
    }

    async getPriceRules(cartItem) {
      try {
        const boldCustomAppUrl =
          "https://api.boldcommerce.com/go_pre/pricerules/0ccab2.myshopify.com";
        const url = `${boldCustomAppUrl}/rulesets?products=${cartItem.product_id}`;
        const response = await fetch(url);
        const data = await response.json();

        if (data.rulesets.length) {
          this.rulesSets = data.rulesets.map((ruleset) => {
            return {
              variantId: ruleset.product_selection.products[0].variant_id,
              rules: ruleset.rules.filter((rule) => rule.type === "DISPLAY"),
            };
          });

          this.updatePriceBasedOnQuantity(cartItem);
        }
      } catch (error) {
        console.error("Error catching rulesets:", error);
      }
    }

    getQuantityBreaks(ruleset) {
      const quantityBreaks = [];
      ruleset.rules.forEach((rule) => {
        rule.actions.forEach((action) => {
          if (action.type === "DISPLAY_QTY_BREAK") {
            quantityBreaks.push(action);
          }
        });
      });

      return quantityBreaks;
    }

    updatePriceBasedOnQuantity(cartItem) {
      const ruleset = this.rulesSets.find(
        (ruleset) => ruleset.variantId == cartItem.variant_id
      );
      const quantityBreaks = this.getQuantityBreaks(ruleset);

      const intervals = [];
      let minQty = 1;
      let currentPrice = cartItem.final_price;

      quantityBreaks.forEach((element) => {
        intervals.push({
          min: minQty,
          max: element.qty - 1,
          price: currentPrice,
        });
        currentPrice = element.price;
        minQty = element.qty;
      });
      intervals.push({
        min: minQty,
        max: 9999999,
        price: currentPrice,
      });

      this.updateDisplayPrice(cartItem, intervals);
    }

    updateDisplayPrice(cartItem, intervals) {
      intervals.forEach((interval) => {
        if (
          this.dataset.qtyAdded >= interval.min &&
          this.dataset.qtyAdded <= interval.max
        ) {
          this.querySelector(".product-final-price").innerHTML =
            theme.money.format(interval.price * this.dataset.qtyAdded);
        }
      });
    }

    log(info) {
      console.log("cart-item-price", JSON.stringify(info));
    }
  }

  customElements.define(customElements.component, cartItemPrice);
}
